import { render, staticRenderFns } from "./SplashIndustry.vue?vue&type=template&id=1a2c39ac&scoped=true&"
import script from "./SplashIndustry.vue?vue&type=script&lang=js&"
export * from "./SplashIndustry.vue?vue&type=script&lang=js&"
import style0 from "./SplashIndustry.vue?vue&type=style&index=0&id=1a2c39ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c39ac",
  null
  
)

export default component.exports